<template>
    <div class="main-container">
        <!-- 导航条 -->
        <div class="navbar">
            <div class="navbar-left">
                <span class="logo"></span>
                <el-menu default-active="1" mode="horizontal" background-color="transparent">
                    <el-menu-item index="1" @click="mian = '首页'">首页</el-menu-item>
                    <el-menu-item index="2" @click="mian = '关于我们'">学校简介</el-menu-item>
                  <!-- <el-menu-item index="3" @click="mian = '服务'">服务</el-menu-item>  -->
                    <el-menu-item index="4" @click="mian = '联系我们'">联系我们</el-menu-item>
                    
                </el-menu>
            </div>
            <!-- <div class="navbar-right">
                <el-button type="primary" @click="handleLogin">登录</el-button>
            </div> -->
        </div>
        <div class="page-header" v-if="mian=='首页'">
            <h1>欢迎来到欧曼谛学子作品集</h1>
            <h3 style="text-indent: -20px;">这里展示了本校学子从学期开始到结束的每一个阶段作品，我们从中选了优秀作品</h3>
        </div>
         <div class="page-header1" v-if="mian=='详情'">
           
        </div>
        <div v-if="mian === '首页'" class="home-content">
             <!-- 页面标题和描述 -->
         <div class="filter-container"> <!-- 新增外部容器 -->
              <div class="butt">
                <el-menu :default-active="activeIndex" class="menu"     popper-append-to-body="false">
                    <el-menu-item index="1"  @click="imag('美妆')"  activeIndex='1'>美妆作品</el-menu-item>
                    <el-menu-item index="2"  @click="imag('美发')"  activeIndex='2'>美发作品</el-menu-item>
                    <el-menu-item index="3"  @click="imag('美容')"  activeIndex='3'>美容作品</el-menu-item>
                    <el-menu-item index="4"  @click="imag('美甲')"  activeIndex='4'>美甲作品</el-menu-item>
                </el-menu>
             </div>
            </div>
            <el-divider class="navbar-divider"></el-divider>
            <div class="scroll" scroll-container>
              <el-row v-for="groupIndex in Math.min(3, Math.ceil(visibleImages.length / 4))" :key="groupIndex"  :gutter="0">
                    <el-col :span="6" v-for="(image, index) in imageUrl.slice((groupIndex - 1) * 4, groupIndex * 4)"
                        :key="index">
                        <div class="image-wrapper" @click="xiangqing(image.id),mian='详情'">
                            <el-image class="fit-image" :src="getUrl(image.workMedia)" lazy></el-image>
                            <div class="image-text">{{ image.workTitle }}</div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div style="margin: 0 auto; width: fit-content;">
                    <el-pagination background @current-change="handleCurrentChange"
                    :current-page.sync="que.pageNum"
                    :page-size="que.pageSize" layout="prev, pager, next" :total="total"  class="pagination">
                    </el-pagination>
                </div>
        </div>
        <div v-else-if="mian === '关于我们'" class="about-us-content">
            <OmdAboutUs></OmdAboutUs>
        </div>
        <div v-else-if="mian === '服务'" class="about-us-content">
            <OmdService></OmdService>
        </div>
        <div v-else-if="mian === '联系我们'" class="about-us-content">
            <OmdContactUs></OmdContactUs>
        </div>
        <div v-else-if="mian==='详情'" class="about-us">
            <WorkComments></WorkComments>
        </div>

        <el-divider class="navbar-divider"></el-divider>

        <div class="foot">
            <div class="foot-1">电话:&nbsp;&nbsp;&nbsp; <a href="tel:0531-55581999"
                    class="aa">0531-55581999</a>&nbsp;&nbsp;&nbsp;
            </div>
            <div class="foot-1">学校地址:山东省济南市历下区文化东路55号</div>
            <div class="foot-1">版权所有:山东欧曼谛职业培训学校有限公司&nbsp;&nbsp;
                <a href="https://beian.miit.gov.cn/#/Integrated/index"
                    class="aa">备案号:鲁ICP备2022036415号</a>&nbsp;&nbsp;&nbsp;
            </div>

        </div>
    </div>

</template>

<script>
import collection from '@/js/collection';
export default {
    ...collection,
};
</script>

<style scoped>

.about-us-content {
    width: 100%;
    max-width: 1600px;
}
.about-us{
    width: 100%;
    max-width: 1200px;
}


.foot {
    width: 100%;
    max-width: 1600px;
    margin-top: 20px;
    /* 调整背景色，让其更柔和，与主题粉色系更融合 */
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 15px;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    text-align: center;
    /* 调整文本颜色，避免过于刺眼 */
    color: #ffffff;
}

.foot-content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.foot-1 {
    margin-bottom: 10px;
}

.foot-item {
    margin: 5px 0;
    font-size: 16px;
}

a {
    text-decoration: none;
    /* 去掉下划线 */
}

.foot .aa {
    color: #fff;
    text-decoration: none;
    /* 去掉下划线 */
    transition: color 0.3s ease;
}

.foot .aa:hover {
    color: #8f8f8f;
    /* 悬停时颜色变为淡粉色 */
}

.main-container {
    /* background: white;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px; */
    width: 100%; /* 关键：让最外层容器占满屏幕宽度 */
  max-width: 1920px; /* 可选：设置全局最大宽度，避免超宽屏幕内容过散 */
  background: white;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  box-sizing: border-box; /* 同样避免padding影响宽度 */
  margin: 0;
}
.home-content{
    width: 100% !important; /* 占满main-container的宽度 */
  max-width: 1600px; /* 与scroll的最大宽度保持一致 */
  display: flex;
  flex-direction: column;
  align-items: center; /* 内部内容居中，但容器本身占满宽度 */
}

.navbar {
   
    max-width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;

    border-radius: 15px;
    /* backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px); */

    margin-bottom: 20px;
    /* 添加导航栏动画效果 */
    transition: all 0.3s ease;

    position: relative; /* 随页面滚动，不固定 */
  width: 100%;
  max-width: 1200px;
  /* 可选：如果需要导航栏半透明背景，用实色替代半透明 */
  background-color: rgba(255, 255, 255, 0.9); /* 提高透明度，减少模糊影响 */
}


.navbar-left {
    display: flex;
    align-items: center;
}

.logo {
    width: 225px;
    height: 50px;
    background: url('@/assets/logo2.png') no-repeat center center/cover;


}

.logo:hover {
    transform: scale(1.1);
}



.navbar-right {
    display: flex;
    align-items: center;
}

.page-header {
    display: flex;
    height: 300px;
    width: 100%;
    /* border: 1px solid #cf0000; */
    background: url('@/assets/youke1.png')no-repeat center center/cover;
    /* text-align: center; */
    margin-bottom: 20px;
    color: #fff;
    /* 添加标题动画效果 */
    animation: fadeInUp 1s ease;
    flex-direction: column;
   /* 核心修改：设置为左上角对齐 */
    flex-direction: column; /* 保持垂直排列 */
    justify-content: flex-end;
    align-items: center;
    padding: 130px 30px 30px 100px; /* 可选：添加内边距，避免文字贴边 */
}
.page-header1 {
    display: flex;
    height: 300px;
    width: 100%;
    border: 1px solid #cf0000;
    background: url('@/assets/banner2.png')no-repeat center center/cover;
    /* text-align: center; */
    margin-bottom: 20px;
    color: #fff;
    /* 添加标题动画效果 */
    animation: fadeInUp 1s ease;
    flex-direction: column;
   /* 核心修改：设置为左上角对齐 */
    flex-direction: column; /* 保持垂直排列 */
    justify-content: flex-end;
    align-items: center;
    padding: 130px 30px 30px 100px; /* 可选：添加内边距，避免文字贴边 */
}





.page-header h1 {}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.page-header h1 {
    font-size: 42px;
    margin-bottom: 15px;
}

.page-header p {
    font-size: 20px;
    opacity: 0.8;
}



::v-deep .custom-select .el-input__inner {
    color: #6b6b6b;
    text-align: center;
    width: 140px;
    font-size: 18px;
    background: rgb(237, 237, 237) !important;
    border: none !important;
}


.el-scrollbar .el-select-dropdown__wrap .el-select-dropdown__list .el-select-dropdown__item {
    color: #000000 !important;

}

.el-scrollbar .el-select-dropdown__wrap .el-select-dropdown__list .el-select-dropdown__item:hover {
    color: #6b6b6b !important;
}

.el-select-dropdown__wrap .el-select-dropdown__list .el-select-dropdown__item {
    background: white !important;
}



.navbar-divider {
    width: 100%;
    max-width: 1600px;
    margin: 0px auto;
}


/* 新增筛选菜单容器样式 */
.filter-container {
      width: 100%;
     max-width: 1600px;
    margin: 0px 0 0px;
   
 
}

.butt {
   max-width: 1200px;
    width: 100%;
    display: flex;
  
    /* 避免容器因内容变化而抖动 */
    overflow: hidden; /* 进一步限制内容范围 */
    float:right;
    
}
/* 重点修改按钮样式 */
.menu {
    border: none;
    display: flex;
    color: #fff;
    /* 避免菜单容器尺寸变化 */
    width: 100%;
    min-width: 500px; /* 根据按钮总宽度设置最小宽度 */
      justify-content: flex-end; /* 关键：靠右对齐 */
 
}

.menu .el-menu-item {
    /* 固定尺寸，避免选中时尺寸变化 */
    width: 120px !important; 
    height: 45px !important;
    line-height: 45px !important;
    margin: 0 5px;
    padding: 0 !important; /* 清除内边距波动 */
    font-size: 18px;
    text-align: center;
    background: #ededed;
    color: #666666 !important;
    cursor: pointer;
    /* 用transform替代margin/padding变化，避免重排 */
   /*box-shadow: 0 2px 8px rgba(224, 34, 77, 0.3); 用阴影突出选中状态*/
}

/* 选中状态样式，只修改颜色和背景，不改变尺寸 */
.menu .el-menu-item.is-active {
    color: #ffffff !important;
    background-color: #e0224d !important;
    /* 可选：添加轻微缩放效果但不影响布局 */
   /* box-shadow: 0 2px 8px rgba(224, 34, 77, 0.3); 用阴影突出选中状态 */
}


.scroll {
  /* 关键：强制占满父容器宽度 */
  width: 100% !important; 
  max-width: 1600px; /* 保持最大宽度限制（如需），但允许在小于1600px时占满 */
    margin: 5px 0;
    box-sizing: border-box; /* 关键：让padding不影响总宽度计算 */
  padding: 20px;
    
  background-color: #f5f5f5;
  border-radius: 20px;
  min-height: 250px;
  /* 确保没有隐藏溢出内容，避免宽度被压缩 */
  overflow: visible;
  max-height: none;

}

.image-wrapper {
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(255, 105, 180, 0.1);
    transition: all 0.3s ease;
    cursor: pointer; 
     margin: 20px; 
    width: calc(100% - 40px); /* 减去左右各40px的margin */
  min-height: 250px;
}


.image-wrapper:hover {
    transform: translateY(-10px);
    box-shadow: 0 8px 16px rgba(255, 105, 180, 0.2);
}

.fit-image {
    
    object-fit: cover;
    display: block;
    width: 100%;
    height: 100%;
}

/* 强制el-col占父元素（el-row）的25% */
::v-deep .el-col {
  width: 25% !important; 
  padding: 0 !important; /* 清除默认padding */
}

/* 确保el-row占满scroll宽度 */
::v-deep .el-row {
  width: 100% !important;
  margin: 0 !important; /* 清除默认margin */
}

.image-text {
    text-align: center;
    padding: 20px;
    color: #FF69B4;
    font-size: 18px;
    background-color: rgba(255, 255, 255, 0.8);
}
</style>
